import { Tween, Easing } from '@tweenjs/tween.js';
import { EVENTS } from '../lib/constants';
import HELPERS from '../lib/globals/helpers/Helpers';
class CloseController {
	constructor(vc, conf) {
		this.vc = vc;
		this.config = conf;
		if (this.vc) {
			if (this.config.holder) {
				this.vc[this.config.holder][this.config.closeBtn].handler =
					this.closeHandler.bind(this);
			} else {
				this.vc.getChildByName(this.config.closeBtn, true).handler =
					this.closeHandler.bind(this);
			}
		} else {
			throw new Error(
				'CloseController failed init ' + JSON.stringify(this.config)
			);
		}
	}
	onClose = (h) => {
		this.handler = h;
	};
	closeHandler() {
		new Tween(this.vc)
			.to({ alpha: 0 }, 100)
			.easing(Easing.Linear.None)
			.onComplete(() => {
				if (this.handler) {
					this.handler();
					HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: '' });
				}
			})
			.start();
	}
}

export default CloseController;
